import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const UpdateDocsData = createAsyncThunk(
    "updateDocsData", async (arg, { rejectWithValue }) => {
        try {
            const resposnse = await doPost(urls.updateDocsData, arg);
            return resposnse;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const UpdateDocsDataSlice = createSlice({
    name: "updateDocsData",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        updateDocsDataReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [UpdateDocsData.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [UpdateDocsData.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [UpdateDocsData.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { updateDocsDataReset } = UpdateDocsDataSlice?.actions;